module.exports = __webpack_public_path__ + "img/info-gatheringS.3b653d75.png";